import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { updatePartPackageByPartId } from "../../../queries/updatePartPackageByPartId";
import { useSetInfoToast } from "../../../stores/hooks/useSetInfoToast";
import { OrderDetails } from "../../../stores/slices/cartSlice";
import { CustomPart } from "../../../stores/slices/packageEditorSlice";
import { PackageInfoForm } from "../PackageInfoForm/PackageInfoForm";
import { VehicleMappingPayload } from "../useVehicleMaping";

export const packageInfoFormId = "package-info-form";

export const PackageInfo: FunctionComponent<{
  customParts: CustomPart[];
  data?: VehicleMappingPayload;
  orderDetails: OrderDetails;
  quoteId: string;
  reset: VoidFunction;
  setIsSending(value: boolean): void;
}> = ({ customParts, data, orderDetails, reset, setIsSending }) => {
  const { t } = useTranslation();
  const setInfoToast = useSetInfoToast();
  const { sendJson: createPackage } = updatePartPackageByPartId(
    orderDetails.dealerId
  );
  return (
    <PackageInfoForm
      onSubmit={async (form): Promise<void> => {
        await createPackage(form);
        setInfoToast({ message: t("packageEditor.packageCreated") });
      }}
      parts={orderDetails.orderItemList.map(
        ({ itemId, itemQty, itemType }) => ({
          partId: itemId,
          partType: itemType,
          quantity: Number(itemQty),
        })
      )}
      advancedPrice={null}
      customParts={customParts}
      id={packageInfoFormId}
      mappedIds={data?.selectedVehicleIds ?? []}
      quoteTotal={orderDetails.orderGrandTotal}
      reset={reset}
      setIsSending={setIsSending}
    />
  );
};
